import type { User } from "firebase/auth";

export type StudentProfileDraft = {
    firstName: string;
    lastName: string;
    qualification: string;
    status: "completed" | "inprogress" | "";
};

export type AuthenticatedStudent = {
    user: User;
    draft: StudentProfileDraft;
};

export function friendlyAuthError(error: any, fallback: string) {
    const messages: Record<string, string> = {
        "auth/invalid-credential": "That email or password is not correct.",
        "auth/invalid-email": "Enter a valid email address.",
        "auth/popup-closed-by-user": "Google sign-in was cancelled.",
        "auth/popup-blocked": "Your browser blocked the Google window. Allow pop-ups and try again.",
        "auth/network-request-failed": "Check your internet connection and try again.",
        "auth/operation-not-allowed": "Email-link sign-in is not enabled yet. Contact MockZo support.",
        "auth/quota-exceeded": "The email sign-in limit has been reached. Please try again later.",
        "auth/too-many-requests": "Too many attempts. Wait a few minutes and try again.",
        "auth/unauthorized-continue-uri": "This website is not authorized for email-link sign-in.",
        "auth/invalid-continue-uri": "The email sign-in return address is invalid. Contact MockZo support.",
        "auth/user-disabled": "This account has been disabled. Contact MockZo support.",
        "auth/unauthorized-domain": "This website is not authorized for Google sign-in.",
    };
    return messages[error?.code] || fallback;
}

export function profileIsComplete(profile: Record<string, any>) {
    return Boolean(
        String(profile.firstName || "").trim()
        && String(profile.lastName || "").trim()
        && String(profile.qualification || "").trim()
        && ["completed", "inprogress"].includes(profile.status),
    );
}

export function profileDraft(user: User, profile: Record<string, any>): StudentProfileDraft {
    const parts = String(profile.name || user.displayName || "").trim().split(/\s+/).filter(Boolean);
    return {
        firstName: profile.firstName || parts[0] || "",
        lastName: profile.lastName || parts.slice(1).join(" ") || "",
        qualification: profile.qualification || "",
        status: profile.status || "",
    };
}
